// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2s-1";
export var rateTableServiceLevelDropdown = "_2s-3";
export var rateTableTypeDropdown = "_2s-0";
export var rateTableValueModeDropdown = "_2s-2";